<template>
  <h1
    v-if="text"
    :class="$style.root"
    v-html="text"
  />
</template>

<script lang="ts" setup>
const props = defineProps<{
  text: string
}>()
</script>

<style module>
.root {
  composes: reset-heading from global;
  composes: font-size-medium from global;

  color: var(--color--secondary);

  transform: translateY(var(--compensation--lh, 0px) / 2);
}
</style>
